import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { FormattedMessage } from '../../../util/reactIntl';
import { NamedLink } from '../../../components';
import { SearchCTA } from '../../../containers/PageBuilder/Primitives/SearchCTA';
import { isMainSearchTypeKeywords } from '../../../util/search';
import { useConfiguration } from '../../../context/configurationContext';
import { GiCheckedShield } from "react-icons/gi";
import { PiSecurityCameraFill } from "react-icons/pi";
import { FaTruckFront } from "react-icons/fa6";
import { withRouter, Redirect, Link, Route, Switch } from "react-router-dom";


import css from './HeroSection.module.css';
// import { Link } from 'react-router-dom';

/**
 * Premium Hero Section component for ChinaDolphins custom homepage
 */
const HeroSection = props => {
  const { className, rootClassName } = props;
  const config = useConfiguration();
  const isKeywordSearch = isMainSearchTypeKeywords(config);

  const searchFields = {
    keywordSearch: true,
    locationSearch: true,
    categories: false,
    dateRange: false,
  };

  const classes = classNames(rootClassName || css.root, className);

  return (
    <>
      <div className={css.hero}>
        <div className={css.heroContent}>
          <h1 className={css.text}>
            <FormattedMessage id="landing.hero.title" values={{ br: <br /> }} />
          </h1>

          <p className={css.para}>
            <FormattedMessage id="landing.hero.subtitle" />
          </p>

          <div className={css.iconcard}>
            <div className={css.icard}>
              <GiCheckedShield size={30} color="#0A1F44" />
              <div className={css.text2}>
                <h3>
                  <FormattedMessage id="landing.hero.badge1Title" />
                </h3>
                <h4>
                  <FormattedMessage id="landing.hero.badge1Desc" />
                </h4>
              </div>
            </div>

            <div className={css.icard}>
              <PiSecurityCameraFill size={30} color="#0A1F44" />
              <div className={css.text2}>
                <h3>
                  <FormattedMessage id="landing.hero.badge2Title" />
                </h3>
                <h4>
                  <FormattedMessage id="landing.hero.badge2Desc" />
                </h4>
              </div>
            </div>

            <div className={css.icard}>
              <FaTruckFront size={30} color="#0A1F44" />
              <div className={css.text2}>
                <h3>
                  <FormattedMessage id="landing.hero.badge3Title" />
                </h3>
                <h4>
                  <FormattedMessage id="landing.hero.badge3Desc" />
                </h4>
              </div>
            </div>
          </div>

          <div className={css.button}>
            <button className={css.button1}>
              <FormattedMessage id="landing.hero.buyerBtn" />
            </button>
            <button className={css.button2}>
              <FormattedMessage id="landing.hero.agentFactoryBtn" />
            </button>
          </div>
        </div>
      </div>
    </>
  );
};

HeroSection.defaultProps = {
  className: null,
  rootClassName: null,
};

HeroSection.propTypes = {
  className: PropTypes.string,
  rootClassName: PropTypes.string,
};

export default HeroSection;
